var map = {
	"./acdelco.svg": 964651,
	"./audi.svg": 236369,
	"./bmw.svg": 906136,
	"./bproauto.svg": 524424,
	"./byd.svg": 994527,
	"./chery.svg": 293627,
	"./chevrolet.svg": 611994,
	"./citroen.svg": 848218,
	"./fiat.svg": 686254,
	"./ford.svg": 499621,
	"./harley-davidson.svg": 694626,
	"./honda motos.svg": 451330,
	"./honda.svg": 771664,
	"./hondamotos.svg": 603394,
	"./hyundai.svg": 222720,
	"./jeep.svg": 342790,
	"./kia.svg": 289639,
	"./mercedes_benz.svg": 998142,
	"./mini.svg": 899071,
	"./mitsubishi.svg": 201331,
	"./mopar.svg": 519715,
	"./motorcraft.svg": 625157,
	"./motrio.svg": 883320,
	"./nissan.svg": 823170,
	"./peugeot.svg": 388037,
	"./renault.svg": 156483,
	"./toyota.svg": 759320,
	"./volkswagen.svg": 340367,
	"./volvo.svg": 642180,
	"./yamaha.svg": 749039
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 160980;